<template>
    <div>
        <b-card>
          <h3>Hot Water</h3>
          <br/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">Minimum Outlet Hot Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.HotWater.OutletMin" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q2</b-col>
            <b-col align="left">Hot Water Return Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.HotWater.HotWaterReturn" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <hr/>
          <h3>Cold Water</h3>
          <br/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">Maximimum Outlet Cold Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.ColdWater.OutletMax" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <b-row>
            <b-col cols="1">Q2</b-col>
            <b-col align="left">Incoming Supply Cold Temp</b-col>
            <b-col><b-form-input type="number" step="0.50" min="0.00" max="100.00" v-model="Values.ColdWater.SupplyTemp" placeholder="00.00"></b-form-input></b-col>
            <b-col align="left">&deg;C</b-col>
          </b-row>
          <hr/>
          <h3>Flow</h3>
          <br/>
          <b-row>
            <b-col cols="1">Q1</b-col>
            <b-col align="left">Expected outlet flow frequency</b-col>
            <b-col><b-form-input type="number" v-model="Values.Flow.OutletFrequency" placeholder="00"></b-form-input></b-col>
            <b-col align="left">Hours</b-col>
          </b-row>
          <hr/>
          <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Page Complete</b-button></b-col></b-row>

        </b-card>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        stepComplete: false,
        InvalidNum: false,
        Values:{
          HotWater: {
                  OutletMin: "",
                  HotWaterReturn: ""
                    },
          ColdWater: {
                  OutletMax: "",
                  SupplyTemp: ""
                    },
          Flow: {
                  OutletFrequency: ""
                    },
                  }
        
      }
    },
    computed: {},
    components: {},
    mounted(){

      if (this.Type == 'Modify'){
        this.Values.HotWater.OutletMin = this.DataPass.HotWater.OutletMin
        this.Values.HotWater.HotWaterReturn = this.DataPass.HotWater.HotWaterReturn
        this.Values.ColdWater.OutletMax = this.DataPass.ColdWater.OutletMax
        this.Values.ColdWater.SupplyTemp = this.DataPass.ColdWater.SupplyTemp
        this.Values.Flow.OutletFrequency = this.DataPass.Flow.OutletFrequency
      } else{
        this.Values.HotWater.OutletMin = 50.35
        this.Values.HotWater.HotWaterReturn = 50.00
        this.Values.ColdWater.OutletMax = 20.00
        this.Values.ColdWater.SupplyTemp = 17.50
        this.Values.Flow.OutletFrequency = 24
      }
      
       
    },
    methods:{
      CompletePage(){

        if (this.NumberCheck(this.Values) == true){
          alert("Please ensure entries contain only valid numbers")
        } else{
        
        this.$emit("PageComplete",2,this.Values)
        this.stepComplete = true;
        }
      },
      NumberCheck(data){
  
        this.InvalidNum = false
        
        let invalidhotmin = /^\d{1,3}(\.\d+)?$/.test(data.HotWater.OutletMin)
        let invalidhotret = /^\d{1,3}(\.\d+)?$/.test(data.HotWater.HotWaterReturn)
        let invalidcoldmax = /^\d{1,3}(\.\d+)?$/.test(data.ColdWater.OutletMax)
        let invalidcoldsupply = /^\d{1,3}(\.\d+)?$/.test(data.ColdWater.SupplyTemp)
        let invalidflow = /^\d+(\.\d{1,3})?$/.test(data.Flow.OutletFrequency)

        if (!invalidhotmin || !invalidhotret || !invalidcoldmax || !invalidcoldsupply || !invalidflow){
          this.InvalidNum = true
        }

        return this.InvalidNum
      }
    },

    }
</script>

<style>

</style>